import styled from 'styled-components';
import { brightBlue, red } from '../../../utils/theme';

export const CarouselWrapper = styled.div`
  .slick-arrow {
    width: 30px;
    height: 30px;
  }
  .slick-dots li button:before {
    background: ${brightBlue};
  }

  .slick-dots li.slick-active button:before {
    background: ${red};
  }

  .article-card {
    margin: 0 12px;
  }

  &.equal-height {
    .slick-track {
      display: flex;

      .slick-slide {
        height: auto;

        > div {
          height: 100%;

          > div {
            height: 100%;
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/carousel/styles/carousel.style.js